/**
 * Admin Invitation API service.
 * Backend: admin_invitations table via admin-management/invitations API.
 */

import api from './api';
import type {
  AdminInvitation,
  InvitationsListResponse,
  InviteAdminPayload,
  InviteAdminResponse,
} from '../types/adminInvitation';

const INVITATIONS_BASE = '/admin/admin-management/invitations';

export interface FetchInvitationsParams {
  page?: number;
  limit?: number;
  status?: string;
  q?: string;
}

export async function fetchInvitations(
  params: FetchInvitationsParams = {}
): Promise<InvitationsListResponse> {
  const { page = 1, limit = 10, status, q } = params;
  const queryParams: Record<string, string | number> = { page, limit };
  if (status) queryParams.status = status;
  if (q?.trim()) queryParams.q = q.trim();

  const res = await api.get<InvitationsListResponse>(INVITATIONS_BASE, {
    params: queryParams,
  });
  return res.data;
}

export async function inviteAdmin(
  payload: InviteAdminPayload
): Promise<InviteAdminResponse> {
  const body = {
    email: payload.email.trim().toLowerCase(),
    role: payload.role,
  };
  const res = await api.post<InviteAdminResponse>(INVITATIONS_BASE, body);
  return res.data;
}

export async function resendInvitation(
  invitationId: string
): Promise<{ success: boolean; message: string; data: AdminInvitation }> {
  const res = await api.post(`${INVITATIONS_BASE}/${invitationId}/resend`);
  return res.data;
}

export async function revokeInvitation(invitationId: string): Promise<void> {
  await api.post(`${INVITATIONS_BASE}/${invitationId}/revoke`);
}
